/*jshint browser:true, eqeqeq:true, undef:true, curly:true, laxbreak:true, forin:false, smarttabs:true */
/*global SAPO:false, s$:false */



if (typeof SAPO === 'undefined') {
    window.SAPO = {};
} else {
    window.SAPO = window.SAPO;
}

/**
 * @class SAPO
 */

/* {{{ SAPO.namespace() */
/**
 * @function {Object} SAPO.namespace Creates the SAPO namespace
 * @param {string} ns - namespace path
 * @return Object with SAPO namespace
 */
SAPO.namespace = function(ns) {

    if (!ns || !ns.length) {
        return null;
    }

    var levels = ns.split(".");
    var nsobj = SAPO;

    // SAPO is implied, so it is ignored if it is included
    for (var i = (levels[0] === "SAPO") ? 1 : 0; i < levels.length; ++i) {
        nsobj[levels[i]] = nsobj[levels[i]] || {};
        nsobj = nsobj[levels[i]];
    }

    return nsobj;
};
/* }}} */

/* {{{ SAPO.extend() */
/*
SAPO.extend = function(subclass, superclass) {
    var f = function() {};
    f.prototype = superclass.prototype;
    subclass.prototype = new f();
    subclass.prototype.constructor = subclass;
    subclass.superclass = superclass.prototype;
    if (superclass.prototype.constructor == Object.prototype.constructor) {
        superclass.prototype.constructor = superclass;
    }
};
*/
/* }}} */

/* {{{ SAPO.safeCall() */
/**
 * @function ? Safely calls a callback function. Verifies that
 *             the callback is well defined and traps errors.
 * @param {Object} object to be used as this. If null, the global object is used.
 *             If function, then it's called with window as this.
 * @param {String|Function} listener member function to be called. If string, then
 *             member is looked up.
 */
SAPO.safeCall = function(object, listener) {
    function rethrow(exception){
        setTimeout(function() {
            // Rethrow exception so it'll land in
            // the error console, firebug, whatever.
            if (exception.message) {
                exception.message += '\n'+(exception.stacktrace || exception.stack || '');
            }
            throw exception;
        },1);
    }
    if (object === null) {
        object = window;
    }
    if (typeof listener === 'string' && typeof object[listener] === 'function') {
        try {
            return object[listener].apply(object, [].slice.call(arguments, 2));
        } catch(ex){
            rethrow(ex);
        }
    } else if (typeof listener === 'function') {
        try {
            return listener.apply(object, [].slice.call(arguments, 2));
        } catch(ex){
            rethrow(ex);
        }
    } else if (typeof object === 'function') {
        try {
            return object.apply(window, [].slice.call(arguments, 1));
        } catch(ex){
            rethrow(ex);
        }
    }
};
/* }}} */

/* {{{ s$() */
/**
 * @function {DOMElement|Array} s$ Shortcut for document.getElementById
 * @param {string|Array} element - Receives either an id or an Array of id's
 * @return Either the DOM element for the given id or an array of elements for the given ids
 */
window.s$ = function(element) {
    if (arguments.length > 1) {
        for (var i = 0, elements = [], length = arguments.length; i < length; i++) {
            elements.push(s$(arguments[i]));
        }
        return elements;
    }
    if (typeof element === 'string') {
        element = document.getElementById(element);
    }
    return element;
};
/* }}} */

/* {{{ Function.bindObj() */
/**
 * @function {Function} bindObj Extends the native Function object.
 * Creates a delegate (callback) that sets the scope to obj.
 * Call directly on any function. <br />Example:
 * <code>this.myFunction.bindObj(this)</code> <br />
 * Will create a function that is automatically scoped to this.
 * @param {Object} obj The object for which the scope is set
 * @param {optional Array} args Overrides arguments for the call.
 * (Defaults to the arguments passed by the caller)
 * @return The new function
 */
Function.prototype.bindObj = function() {

    if (arguments.length < 2 && arguments[0] === undefined) {
        return this;
    }
    var __method = this;
    var args = [];
    for(var i=0, total=arguments.length; i < total; i++) {
        args.push(arguments[i]);
    }
    var object = args.shift();

    var fn = function() {
        return __method.apply(object, args.concat(function(tmpArgs){
                        var args2 = [];
                        for(var j=0, total=tmpArgs.length; j < total; j++) {
                            args2.push(tmpArgs[j]);
                        }
                        return args2;
                    }(arguments)));
    };
    fn.toString = function(){ return String(__method); };
    fn.name = fn.displayName = __method.name;
    return fn;
};
/* }}} */

/* {{{ Function.bindObjEvent() */
/**
 * @function {Function} bindObjEvent Extends the native Function object.
 * Creates a delegate (callback) that sets the scope to obj.
 * Call directly on any function. <br />Example:
 * <code>this.myFunction.bindObjEvent(this)</code> <br />
 * Will create a function that is automatically scoped to this.
 * @param {Object} event The default event
 * @param {Object} obj The object for which the scope is set
 * @param {optional Array} args Overrides arguments for the call.
 * (Defaults to the arguments passed by the caller)
 * @return The new function
 */
Function.prototype.bindObjEvent =  function() {
    var __method = this;
    var args = [];
    for(var i=0; i < arguments.length; i++) {
        args.push(arguments[i]);
    }
    var object = args.shift();
    return function(event) {
        return __method.apply(object, [event || window.event].concat(args));
    };
};
/* }}} */

/* {{{ SAPO.extendObj() */
/**
 * @function {Object} ? Extends a given Object with a given set
 * of properties
 * @param {Object} destination - The original objecty
 * @param {Object} source - The new properties
 * @return The extended object
 */
SAPO.extendObj = function(destination, source) {
    if (source) {
        for (var property in source) {
            if(source.hasOwnProperty(property)){
                destination[property] = source[property];
            }
        }
    }
    return destination;
};
/* }}} */

/* {{{ SAPO.Browser */
/**
 * @class {private} SAPO.Browser
 */
if (typeof SAPO.Browser === 'undefined') {

    SAPO.Browser = {
        /**
         * True if the browser is Internet Explorer
         * @var {boolean} ?
         */
        IE: false,

        /**
         * True if the browser is Gecko based
         * @var {boolean} ?
         */
        GECKO: false,

        /**
         * True if the browser is Opera
         * @var {boolean} ?
         */
        OPERA: false,

        /**
         * True if the browser is Safari
         * @var {boolean} ?
         */
        SAFARI: false,

        /**
         * True if the browser is Konqueror
         * @var {boolean} ?
         */
        KONQUEROR: false,

        /**
         * True if browser is Chrome
         * @var {boolean} ?
         */

        CHROME: false,

        /**
         * The specific browser model
         * @var {string} ?
         */
        model: false,

        /**
         * The browser version
         * @var {string} ?
         */
        version: false,

        /**
         * The user agent string
         * @var {string} ?
         */
        userAgent: false,

        /**
         * @function ? initialization function for the Browser object
         */
        init: function()
        {
            this.detectBrowser();
            this.setDimensions();
            this.setReferrer();
        },

        /**
         * @function ? Stores window dimensions
         */
        setDimensions: function()
        {
            //this.windowWidth=window.innerWidth !== null? window.innerWidth : document.documentElement && document.documentElement.clientWidth ? document.documentElement.clientWidth : document.body !== null ? document.body.clientWidth : null;
            //this.windowHeight=window.innerHeight != null? window.innerHeight : document.documentElement && document.documentElement.clientHeight ? document.documentElement.clientHeight : document.body != null? document.body.clientHeight : null;
            var myWidth = 0, myHeight = 0;
            if ( typeof window.innerWidth=== 'number' ) {
                myWidth = window.innerWidth;
                myHeight = window.innerHeight;
            } else if( document.documentElement && ( document.documentElement.clientWidth || document.documentElement.clientHeight ) ) {
                myWidth = document.documentElement.clientWidth;
                myHeight = document.documentElement.clientHeight;
            } else if( document.body && ( document.body.clientWidth || document.body.clientHeight ) ) {
                myWidth = document.body.clientWidth;
                myHeight = document.body.clientHeight;
            }
            this.windowWidth = myWidth;
            this.windowHeight = myHeight;
        },

        /**
         * @function ? Stores the referrer
         */
        setReferrer: function()
        {
            this.referrer = document.referrer !== undefined? document.referrer.length > 0 ? window.escape(document.referrer) : false : false;
        },

        /**
         * @function ? Detects the browser and stores the found properties
         */
        detectBrowser: function()
        {
            var sAgent = navigator.userAgent;

            this.userAgent = sAgent;

            sAgent = sAgent.toLowerCase();

            if((new RegExp("applewebkit\/")).test(sAgent)) {

                if((new RegExp("chrome\/")).test(sAgent)) {
                    // Chrome
                    this.CHROME = true;
                    this.model = 'chrome';
                    this.version = sAgent.replace(new RegExp("(.*)chrome\/([^\\s]+)(.*)"), "$2");
                    this.cssPrefix = '-webkit-';
                    this.domPrefix = 'Webkit';
                } else {
                    // Safari
                    this.SAFARI = true;
                    this.model = 'safari';
                    this.version = sAgent.replace(new RegExp("(.*)applewebkit\/([^\\s]+)(.*)"), "$2");
                    this.cssPrefix = '-webkit-';
                    this.domPrefix = 'Webkit';
                }
            } else if((new RegExp("opera")).test(sAgent)) {
                // Opera
                this.OPERA = true;
                this.model = 'opera';
                this.version = sAgent.replace(new RegExp("(.*)opera.([^\\s$]+)(.*)"), "$2");
                this.cssPrefix = '-o-';
                this.domPrefix = 'O';
            } else if((new RegExp("konqueror")).test(sAgent)) {
                // Konqueror
                this.KONQUEROR = true;
                this.model = 'konqueror';
                this.version = sAgent.replace(new RegExp("(.*)konqueror\/([^;]+);(.*)"), "$2");
                this.cssPrefix = '-khtml-';
                this.domPrefix = 'Khtml';
            } else if (/(msie|trident)/i.test(sAgent)) {
                // MSIE
                this.IE = true;
                this.model = 'ie';
                if (/rv:((?:\d|\.)+)/.test(sAgent)) {  // IE 11
                    this.version = sAgent.match(/rv:((?:\d|\.)+)/)[1];
                }
                else {
                    this.version = sAgent.replace(/(.*)\smsie\s([^;]+);(.*)/, "$2");
                }
                this.cssPrefix = '-ms-';
                this.domPrefix = 'ms';
            } else if((new RegExp("gecko")).test(sAgent)) {
                // GECKO
                // Supports only:
                // Camino, Chimera, Epiphany, Minefield (firefox 3), Firefox, Firebird, Phoenix, Galeon,
                // Iceweasel, K-Meleon, SeaMonkey, Netscape, Songbird, Sylera,
                this.GECKO = true;
                var re = new RegExp("(camino|chimera|epiphany|minefield|firefox|firebird|phoenix|galeon|iceweasel|k\\-meleon|seamonkey|netscape|songbird|sylera)");
                if(re.test(sAgent)) {
                    this.model = sAgent.match(re)[1];
                    this.version = sAgent.replace(new RegExp("(.*)"+this.model+"\/([^;\\s$]+)(.*)"), "$2");
                    this.cssPrefix = '-moz-';
                    this.domPrefix = 'Moz';
                } else {
                    // probably is mozilla
                    this.model = 'mozilla';
                    var reVersion = new RegExp("(.*)rv:([^)]+)(.*)");
                    if(reVersion.test(sAgent)) {
                        this.version = sAgent.replace(reVersion, "$2");
                    }
                    this.cssPrefix = '-moz-';
                    this.domPrefix = 'Moz';
                }
            }
        },

        debug: function()
        {
            /*global alert:false */
            var str = "known browsers: (ie, gecko, opera, safari, konqueror) \n";
                str += [this.IE, this.GECKO, this.OPERA, this.SAFARI, this.KONQUEROR] +"\n";
                str += "model -> "+this.model+"\n";
                str += "version -> "+this.version+"\n";
                str += "\n";
                str += "original UA -> "+this.userAgent;

                alert(str);
        }
    };

    SAPO.Browser.init();

}
/* }}} */